export class CategoryCatalogListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            courses_catelog: lang.academy[0],                 
            categoryCode: lang.academy[1],                 
            sno: lang.academy[2],                 
            courseTitle: lang.academy[3],                 
            coursesCategory: lang.academy[4],                 
            durationHours: lang.academy[5],                 
            noofModules: lang.academy[6],                 
            action: lang.academy[7],                 
            selectColumns: lang.general[9],                 
            selectAll: lang.general[10],                 
            activeColumns: lang.general[11],                 
            close: lang.general[17],                 
            exportCSV: lang.general[13],                 
            exportPDF: lang.general[14],                 
            exportExcel: lang.general[15],                 
            print: lang.general[16],                 
            importCourses: lang.academy[96],                 
            todownloadcsvformat: lang.academy[97],                 
            save: lang.academy[221],                 
        }


    }

    lang() {
        return this.variables;
    }

}

export class CategoryViewListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            courses_catelog: lang.academy[0],                 
            categoryCode: lang.academy[1],                 
            sno: lang.academy[2],                 
            courseTitle: lang.academy[3],                 
            coursesCategory: lang.academy[4],                 
            durationHours: lang.academy[5],                 
            noofModules: lang.academy[6],                 
            action: lang.academy[7],                 
            selectColumns: lang.general[9],                 
            selectAll: lang.general[10],                 
            activeColumns: lang.general[11],                 
            close: lang.general[17],                 
            exportCSV: lang.general[13],                 
            exportPDF: lang.general[14],                 
            exportExcel: lang.general[15],                 
            print: lang.general[16],                 
            importCourses: lang.academy[96],                 
            todownloadcsvformat: lang.academy[97],                 
            save: lang.academy[221],                 
            history: lang.academy[18],                 
            generalData: lang.academy[16],                 
            instances: lang.academy[39],                 
            totalHours: lang.academy[33],                 
            totalAttendies: lang.academy[34],                 
            averageLevel: lang.academy[35],                 
            averageCourseScore: lang.academy[36],                 
            averageTeacherScore: lang.academy[37],                 
            instance: lang.academy[38],                 
            startDate: lang.academy[40],                 
            endDate: lang.academy[41],                 
            status: lang.academy[42],                 
            customer: lang.academy[43],                 
            attendies: lang.academy[44],                 
            teacher: lang.academy[45],                 
            averageCourseLevel: lang.academy[46],                 
            courseScore: lang.academy[47],                 
            teacherScore: lang.academy[48],                 
        }


    }

    lang() {
        return this.variables;
    }

}
